import { render, staticRenderFns } from "./ImageTagsDialog.vue?vue&type=template&id=70314f26&scoped=true"
import script from "./ImageTagsDialog.vue?vue&type=script&lang=js"
export * from "./ImageTagsDialog.vue?vue&type=script&lang=js"
import style0 from "./ImageTagsDialog.vue?vue&type=style&index=0&id=70314f26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70314f26",
  null
  
)

export default component.exports